/**
 * DÉPRÉCIÉ : Utiliser UnifiedErrorService à la place.
 */
import { errorService, AppError } from './unifiedErrorService';

export { AppError };
export const ErrorService = {
    getInstance: () => errorService,
    handleServiceError: (error: any, context: string, service: string) => {
        throw errorService.handleError(error, `${service}:${context}`);
    }
};

export const createValidationError = (msg: string) => new AppError(msg, 'VALIDATION_ERROR', 400);
export const createAuthError = (msg?: string) => new AppError(msg || 'Auth error', 'AUTH_ERROR', 401);

/**
 * Rétrocompatibilité pour userService et autres services utilisant l'ancienne signature
 */
export const handleServiceError = (error: any, context: string, service: string) => {
    throw errorService.handleError(error, `${service}:${context}`);
};
